<button
  matRipple
  class="mg-button"
  [disabled]="disabled">
  <ng-content></ng-content>
</button>
